import React from "react";
import { Typography, Card, CardContent, Divider, Grid } from "@mui/material";
import { useSelectedBusiness } from "../../../redux/store";
import { BookingType, Staff } from "../../../types";

interface SpecificBookingTypeInfo {
  bookingTypeId: number;
  title: string;
  time: number;
  assignedStaff: Staff;
  color: string;
  price: number;
}

const BookingTypeStaffForm = (props: any) => {
  const selectedStaff = props.staff;
  const selectedBusiness = useSelectedBusiness();
  const bookingTypes = selectedBusiness?.businessBookingTypes;
  const businessStaffs = selectedBusiness?.businessStaffs;

  // Get only the booking types associated with the selected staff
  const specificBookingTypesInfos = getSpecificBookingTypesInfo(
    selectedStaff.id,
    bookingTypes ?? [],
    businessStaffs ?? []
  );

  function getSpecificBookingTypesInfo(
    staffId: number,
    bkingTypes: BookingType[],
    staffs: any[]
  ): SpecificBookingTypeInfo[] {
    const results: SpecificBookingTypeInfo[] = [];

    bkingTypes.forEach((bookingType) => {
      // Find if this booking type is assigned to the selected staff
      const assignedStaff = bookingType.assignedStaffs.find(
        (staff: any) => Number(staff.staffId) === Number(staffId)
      );
      if (assignedStaff) {
        results.push({
          bookingTypeId: bookingType.id,
          title: bookingType.title,
          time: bookingType.length,
          assignedStaff: assignedStaff,
          color: bookingType.color,
          price: bookingType.price,
        });
      }
    });

    return results;
  }

  return (
    <Grid container spacing={2}>
      {specificBookingTypesInfos.map(
        (info: SpecificBookingTypeInfo, index: number) => (
          <Grid item xs={12} key={index}>
            <Card
              sx={{
                display: "flex",
                flexDirection: "row",
                height: "100%",
                borderLeft: `3px solid ${info.color}`,
              }}
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Grid container direction="column">
                  <Grid item>
                    <Typography variant="h6" component="div">
                      {info.title.split(" ").slice(0, 5).join(" ")}
                      {info.title.split(" ").length > 5 ? "..." : ""}
                    </Typography>
                  </Grid>
                  <Grid item container direction="row">
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ mt: 1 }}
                    >
                      {info.time} mins
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ mt: 1, ml: 1 }}
                    >
                      {info.price !== null ? `$${info.price}` : "Free"}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
              <Divider orientation="vertical" flexItem />
            </Card>
          </Grid>
        )
      )}
    </Grid>
  );
};

export default BookingTypeStaffForm;
